'use client';

import { useMedia } from '@core/hooks/use-media';
import { HomeSolutionsScroll } from './home-solutions-scroll';
import { HomeSolutionsSwiper } from './home-solutions-swiper';

const DESKTOP_SCROLL_QUERY =
  '(min-width: 1367px) and (min-height: 820px) and (max-aspect-ratio: 21/9) and (hover: hover) and (pointer: fine)';

export function HomeSolutions() {
  const supportsDesktopScroll = useMedia(DESKTOP_SCROLL_QUERY, false);
  const prefersReducedMotion = useMedia(
    '(prefers-reduced-motion: reduce)',
    false
  );

  if (supportsDesktopScroll && !prefersReducedMotion) {
    return <HomeSolutionsScroll />;
  }

  return (
    <div
      className="ship-smart-content-rail container !mt-[clamp(40px,6vw,72px)]"
      data-solutions-mode="swiper"
    >
      <HomeSolutionsSwiper />
    </div>
  );
}
